<template>
    <div>
        <div class="CenMonitor-title">
            <div>{{ $t('alarms.network.cen.cen') }}</div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.network.cen.cen')">
                    <div class="CenMonitor-top">
                        <cen-search></cen-search>
                    </div>
                    <table-cen></table-cen>
                </TabPane>
            </Tabs>
        </template>
        
    </div>
</template>

<script>
    import CenSearch from '../cen/CenSearch'
    import TableCen from '../cen/TableCen'

    export default {
        name: 'CenMonitor',
        components: {
            CenSearch,
            TableCen
        }
    }
</script>

<style scoped>
    .CenMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .CenMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .CenMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/cen/CenMonitor.vue